export const API_BASE_URL = 'https://admin.xodesoftware.com';
export const SK = 'Ane%f$nps!399vs2';

export const SUCCESS_COLOR = '#01427e';
export const FAILED_COLOR = '#d32f2f';
